<script>
import baseview from '@/components/base/baseview'
import {fn_Login } from '@/framework/login/login'
import Cookies from 'js-cookie'
import LoginFail from '@/layout/login/LoginFail'
import router from '@/router'

export default {
  name: 'moceanLogin',
  mixins: [baseview],
  components: {
    LoginFail,
  },
  data() {
    return {
      showPassword:false,
      showFail: false,
      userData: {
        userId: '',
        userPw: '' ,
        sysId: '',
        // system: 'SMART',
      },
      isSaveID: false,
      image: require(`@/assets/images/bg/bg_login.jpg`),
      snackbar: false,
      msg: '',
      timeout: 2000,       
    }
  },
  mounted() {     
      //this.userData.userId =  this.$route.query.moceanID;      
      //this.signIn()  
  },   
  created() {    
       this.userData.userId = this.$route.query.moceanID;    
       this.signIn()      
  },
  methods: {
    // log in
    signIn() {        

       this.userData.userPw = 'MOCEAN'  
      //  this.userData.sysId = '21'  
       fn_Login(this.userData).then((res) => {
           if (res.result) {
            //  console.log('res.result : ', res.result )  
             router.push('/mainLayout')          
            //  this.$router.push({ name: 'v80Menu' }) ;  // 👉 Điều hướng ngay tại đây           
           } else {
             if(res.msg !== 'loginFail') {
               this.snackbar = true
               this.msg = res.msg
             } else {
               this.showFail = true
             }
           }
         })

    },   
  },
}
</script>